import { SxProps, Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const wrapperContentStyles: SxProps<Theme> = {
  mt: 0,
  minHeight: 'calc(100vh - 96px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexFlow: 'column'
}

export default makeStyles()((theme: Theme) => ({
  container: {
    width: '100%',
    maxWidth: 600
  },
  verificationInputRow: {
    marginTop: theme.spacing(6)
  },
  errorRow: {
    textAlign: 'center',
    marginBottom: theme.spacing(6)
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: '16px'
  },
  submitRow: {
    marginTop: theme.spacing(4),
    textAlign: 'center'
  }
}))
